let windowWidth = window.innerWidth;

function initNavEvents() {
    let mainNavItems = document.querySelectorAll('.main-header--nav-item-with-menu');
    let allMegaMenus = document.querySelectorAll('.main-header--mega-menu');

    mainNavItems.forEach((item) => {
        item.addEventListener('click', (e) => {
            closeSearch();
            toggleMegaMenu(e);
        });
    });

    allMegaMenus.forEach((megaMenu) => {
        initSubMenusEvents(megaMenu);
    });
}

function toggleMegaMenu(e) {
    let target = e.currentTarget;
    let eventType = e.type;
    let menuName = target.getAttribute('data-menu');
    let megaMenu = document.querySelector('.main-header--mega-menu[data-menu="' + menuName + '"]');
    let allMegaMenus = document.querySelectorAll('.main-header--mega-menu');
    let mainMobileMenu = document.querySelector('.main-header--nav');
    let firstLevelMenu = megaMenu.querySelector('.nav-dropdown-inner');

    if(!target.classList.contains('active') || windowWidth <= 1024) {
        allMegaMenus.forEach((menu) => {
            if (menu !== megaMenu) {
                menu.classList.remove('active');
                menu.classList.remove('visible');

                let links = menu.querySelectorAll('.mega-menu--item-with-menu');
                links.forEach((link) => {
                    link.classList.remove('active');
                });
                let subMenus = menu.querySelectorAll('.mega-menu--col-2');
                subMenus.forEach((sub) => {
                    if(sub.getAttribute('data-submenu') === "default") {
                        sub.classList.add('active');
                    } else {
                        sub.classList.remove('active');
                    }
                });

            } else {

                menu.classList.add('visible');
                // Set container display to flex first then after a short delay do the animation.
                setTimeout(function() {
                    menu.classList.add('active');
                }, 50);

            }
        });
        let allNavItems = document.querySelectorAll('.main-header--nav-item-with-menu');
        allNavItems.forEach((item) => {
            if (item !== target) {
                item.classList.remove('active');
            } else {
                item.classList.add('active');
            }
        });

        mainMobileMenu.classList.remove('active');
        firstLevelMenu.classList.add('active');
        //toggleOverlay();
    } else {
        closeNav();
    }


}

function initSubMenusEvents(megaMenu) {
    let megaMenuLinks = megaMenu.querySelectorAll('.mega-menu--item-with-menu');

    megaMenuLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            toggleSubMenu(link, megaMenu, megaMenuLinks);
        });
    });
}

function toggleSubMenu(activeLink, megaMenu, megaMenuLinks) {
    let secondLevelMenu = megaMenu.querySelectorAll('.nav-dropdown-inner');

    if(windowWidth > 1024 && activeLink.classList.contains('active')) {
    
        megaMenuLinks.forEach((link) => {
            link.classList.remove('active');
        });
    
    
        secondLevelMenu.classList.remove('active');
    } else {
    
        megaMenuLinks.forEach((link) => {
            if (link !== activeLink) {
                link.classList.remove('active');
            } else {
                link.classList.add('active');
            }
        });
    
    
        secondLevelMenu.classList.remove('active');
    }


}

function setMegaMenuImage(megaMenuName, event) {
    let target = event.target;
    let megaMenu = document.querySelector('.main-header--mega-menu[data-menu="' + megaMenuName + '"]');
    let featuredImage = target.querySelector('img');
    let defaultImage = megaMenu.querySelector('.mega-menu--image-default');
    let alt = featuredImage.getAttribute('alt');
    let src = featuredImage.getAttribute('src');
    let srcset = featuredImage.getAttribute('srcset');
    let imageEl = megaMenu.querySelector('.mega-menu--image');
    let imageCol = megaMenu.querySelector('.mega-menu--col-3');
    imageEl.setAttribute('src', src);
    imageEl.setAttribute('alt', alt);
    imageEl.setAttribute('srcset', srcset);
    imageCol.classList.add('active');
    defaultImage.classList.remove('active');
    imageEl.classList.add('active');
};

function toggleMobileMenu() {
    let mobileMenuBtn = document.querySelector('.main-header--mobile-menu-open');
    let mobileMenu = document.querySelector('.main-header--nav-wrapper');
    let firstLevelMenu = mobileMenu.querySelector('.main-header--nav');
    let body = document.body;


    if(mobileMenuBtn.getAttribute('data-status') === 'closed') {
        mobileMenuBtn.setAttribute('data-status', 'open');
        mobileMenuBtn.classList.add('active');
        mobileMenu.classList.add('active');
        firstLevelMenu.classList.add('active');
		body.classList.add('mobile-nav-open');
    } else {
        mobileMenuBtn.setAttribute('data-status', 'closed');
        mobileMenuBtn.classList.remove('active');
        mobileMenu.classList.remove('active');
        firstLevelMenu.classList.remove('active');
        closeNav();
    }
};

function mobileMenuBack(btn) {
    let backToMenu = btn.getAttribute('data-back-to');

    if(backToMenu === 'main') {
        let firstLevelMenu = document.querySelector('.main-header--nav');
        let megaMenu = document.querySelector('.main-header--mega-menu.active');
        let secondLevelMenu = megaMenu.querySelector('.nav-dropdown-inner.active');
        firstLevelMenu.classList.add('active');
        secondLevelMenu.classList.remove('active');
        megaMenu.classList.remove('active');
    } 
}

function initBackBtnsMobile() {
    let backBtns = document.querySelectorAll('.mega-menu--back-btn');
    backBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            mobileMenuBack(btn);
        });
    });
}

function setDropDownPosition() {
    let dropDownMenus = document.querySelectorAll('.main-header--dropdown-menu');
    
    dropDownMenus.forEach((menu) => {
        let menuName = menu.getAttribute('data-menu');
        let mainLink = document.querySelector('.main-header--nav-item[data-menu="' + menuName + '"]');
        let mainLinkPosition = mainLink.getBoundingClientRect();
        let mainLinkWidth = mainLink.offsetWidth;
        let menuWidth = menu.offsetWidth;   

        if(windowWidth > 819) {
            if(windowWidth >= 1280) {
                let margins = (windowWidth - 1280) / 2;
                menu.style.left = (mainLinkPosition.left + mainLinkWidth - menuWidth - margins) + 'px';

            } else {
                menu.style.left = (mainLinkPosition.left + mainLinkWidth - menuWidth) + 'px';
            }

        } else {
            menu.style.left = '0';
        }
    })
}

function predictiveSearch(searchTerm) {
    const predictiveSearchSection = document.querySelector('.predictive-search-results');
    let suggestedSearch = document.querySelector('.search-suggestions-wrapper');
    let requestResponse;
    let allSearch = `search/suggest?q=${searchTerm}&section_id=predictive-search`;

    fetch(window.Shopify.routes.root + allSearch)
    .then((response) => {
        requestResponse = response;
        return response.text();
       })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }
    
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
    
        predictiveSearchSection.innerHTML = resultsMarkup;
        predictiveSearchSection.classList.add('active');
        suggestedSearch.classList.remove('active');
      })
      .catch((error) => {
        console.error(error);
      });

}

function closeNav() {
    let wrapper = document.querySelector('.main-header--nav-wrapper')
    let navMobileBtn = document.querySelector('.main-header--mobile-menu-open')
    let allMegaMenus = document.querySelectorAll('.main-header--mega-menu');
    let allNavItems = document.querySelectorAll('.main-header--nav-item-with-menu');
    let mainMobileMenu = document.querySelector('.main-header--nav');
    let mainLinks = document.querySelectorAll('.main-header--nav-item');
    let menuMenuItems = document.querySelectorAll('.mega-menu--item-with-menu');
    let col2 = document.querySelectorAll('.mega-menu--col-2');
    let col3 = document.querySelectorAll('.mega-menu--col-3');
    
    
    wrapper.classList.remove('active');
    navMobileBtn.classList.remove('active');
    navMobileBtn.dataset.status = 'closed';
	document.body.classList.remove('mobile-nav-open');

    allMegaMenus.forEach((menu) => {
        menu.classList.remove('visible');
        menu.classList.remove('active');
    });

    allNavItems.forEach((item) => {
        item.classList.remove('active');
    });

    mainMobileMenu.classList.remove('active');

    mainLinks.forEach((link) => {
        link.classList.remove('active');
    });

    menuMenuItems.forEach((item) => {
        item.classList.remove('active');
    });

    col2.forEach((col) => {
        if(col.getAttribute('data-submenu') === "default") {
            col.classList.add('active');
        } else {
            col.classList.remove('active');
        }
    });

    col3.forEach((col) => {
        let defaultImage = col.querySelector('.mega-menu--image-default');
        let featuredImage = col.querySelector('.mega-menu--image');
        col.classList.remove('active');
        defaultImage.classList.add('active');
        featuredImage.classList.remove('active');
    });

    //();
}

function closeSearch() {
    let searchForm = document.querySelector('.nav-search-form');
    let suggestedSearch = document.querySelector('.search-suggestions-wrapper');
    let predictiveSearchResults = document.querySelector('.predictive-search-results');


    searchForm.classList.remove('active');
    suggestedSearch.classList.remove('active');
    predictiveSearchResults.classList.remove('active');
   //toggleOverlay();
}

let searchFocusHandler = null;
let searchMouseEnterHandler = null;
let searchClickHandler = null;

function initSearchEventListeners() {
    let searchForm = document.querySelector('.nav-search-form');
    let searchInput = searchForm.querySelector('input');
    let suggestedSearch = document.querySelector('.search-suggestions-wrapper');
    let predictiveSearchResults = document.querySelector('.predictive-search-results');

    // Remove existing handlers to prevent duplicates
    if (searchFocusHandler) {
        searchInput.removeEventListener('focus', searchFocusHandler);
        searchFocusHandler = null;
    }
    if (searchMouseEnterHandler) {
        searchForm.removeEventListener('mouseenter', searchMouseEnterHandler);
        searchMouseEnterHandler = null;
    }
    if (searchClickHandler) {
        searchInput.removeEventListener('click', searchClickHandler);
        searchClickHandler = null;
    }

    if(windowWidth > 1024) {
        searchFocusHandler = (e) => {
            searchForm.classList.add('active');

            if(predictiveSearchResults.classList.contains('active')) {
                suggestedSearch.classList.remove('active');
            } else {
                suggestedSearch.classList.add('active');
            }

            //toggleOverlay();
            closeNav();
        };
        searchInput.addEventListener('focus', searchFocusHandler);

    } else {
        searchClickHandler = (e) => {
            searchForm.classList.add('active');

            if(predictiveSearchResults.classList.contains('active')) {
                suggestedSearch.classList.remove('active');
            } else {
                suggestedSearch.classList.add('active');
            }

            //toggleOverlay();
            closeNav();
        };
        searchInput.addEventListener('click', searchClickHandler);
    }
}

function initSearch() {
    let searchForm = document.querySelector('.nav-search-form');
    let searchInput = searchForm.querySelector('input');
    let suggestedSearch = document.querySelector('.search-suggestions-wrapper');
    let predictiveSearchResults = document.querySelector('.predictive-search-results');
    let searchClearBtn = searchForm.querySelector('button[type="reset"]');

    initSearchEventListeners();

    searchInput.addEventListener('input', (e) => {
        let value = e.target.value;
        if(value.length > 0) {
            predictiveSearch(value);
        } else {
            suggestedSearch.classList.add('active');
            predictiveSearchResults.classList.remove('active');
        }
    });

    searchClearBtn.addEventListener('click', (e) => {
        searchInput.value = '';
        closeSearch();
    });

    document.addEventListener('click', (e) => {
        if(e.target !== searchInput && e.target !== searchClearBtn) {
            closeSearch();
        }
    });
}

function toggleOverlay() {
    let overlay = document.querySelector('.PageOverlay');
    let body = document.querySelector('body');
    let search = document.querySelector('.nav-search-form.active') ? true : false;
    let nav = document.querySelector('.main-header--mega-menu.active') ? true : false;
    let cart = document.querySelector('.Drawer[aria-hidden=false]') ? true : false

    if(nav || search || cart) {
        overlay.classList.add('is-visible');
        body.classList.add('no-scroll');
    } else {
        overlay.classList.remove('is-visible');
        body.classList.remove('no-scroll');
    }

}

window.addEventListener('DOMContentLoaded', () => {
    setDropDownPosition();
    initNavEvents();
    initBackBtnsMobile();
    initSearch();
});

let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        const previousWindowWidth = windowWidth;
        windowWidth = window.innerWidth;
        initSearchEventListeners();
        setDropDownPosition();

        // Added to prevent dekstop menu showing on top of mobile menu when resizing from desktop to mobile
        if (previousWindowWidth >= 1024 && windowWidth < 1024) {
            closeNav();
        }

    }, 150);
});
